import { faBars, faUser, faGift, faLink, faComments, faWallet, faTicketAlt, faClipboardCheck, faGear, faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';


export default function Sidebar({ active, setActive }) {
    const navigate = useNavigate();


    const Sidebarnav = [
        { id: 'div1', label: 'Overview', icon: 'Overview.svg' },
        { id: 'div2', label: 'Transactions', icon: 'menu.svg' },
        { id: 'div3', label: 'Change password', icon: 'Goal.svg' },
        // { id: 'div4', label: 'Settings', icon: 'Settingsd.svg' },
    ];

    const Sidebar_mobile_nav = [
        { id: 'div5', label: 'Users data', icon: 'Overview.svg' },
        { id: 'div6', label: 'Transaction History', icon: 'menu.svg' },
    ];

    const handleLogout = () => {
        sessionStorage.removeItem('admin');
        localStorage.removeItem('token');
        navigate('/admin/login');
    };

    return (
        <div className="h-full w-[20%] lg:fixed ">
            <div className={`hidden lg:block w-[100%] h-full`}>
                <ul className="space-y-2 font-medium bg-[#191919] h-full py-5 2xl:py-10 flex flex-col">
                    <div className=" flex items-center justify-center gap-2">
                        <div>
                            <img src="/assets/Logo/logo.svg" className="w-14" />
                        </div>
                        <div>
                            <p className="font-bold text-lg font-Artemus ">Stabilix</p>
                        </div>
                    </div>
                    <div className="flex flex-1 w-full">
                        <div className="w-full mt-5 text-base 2xl:text-lg px-5 2xl:px-7 space-y-3">
                            <div className='flex justify-center'><p className='border-b px-2'>Web App</p></div>
                            {Sidebarnav.map((item) => (
                                <button
                                    key={item.id}
                                    className={`w-full text-start rounded-md ${active === item.id ? 'bg-[#856E4F] ' : ''}`}
                                    onClick={() => setActive(item.id)}
                                >
                                    <div className="py-2 2xl:py-3 px-3 2xl:px-7 flex items-center gap-5">
                                        <img src={`/assets/other/${item.icon}`}></img>
                                        {item.label}
                                    </div>
                                </button>
                            ))}
                            <div className='flex justify-center'><p className='border-b px-2'>Mobile App</p></div>
                            {Sidebar_mobile_nav.map((item) => (
                                <button
                                    key={item.id}
                                    className={`w-full text-start rounded-md ${active === item.id ? 'bg-[#856E4F] ' : ''}`}
                                    onClick={() => setActive(item.id)}
                                >
                                    <div className="py-2 2xl:py-3 px-3 2xl:px-7 flex items-center gap-5">
                                        <img src={`/assets/other/${item.icon}`}></img>
                                        {item.label}
                                    </div>
                                </button>
                            ))}
                        </div>
                    </div>
                    <button className='flex items-center gap-5 py-2 2xl:py-3 duration-500 hover:bg-white/5 rounded-md mx-5 2xl:mx-7 px-4 2xl:px-7' onClick={handleLogout}>
                        <FontAwesomeIcon icon={faArrowRightFromBracket} />
                        <p>Logout</p>
                    </button>
                </ul>
            </div>
        </div>
    );
}
